module.exports = __webpack_public_path__ + "img/app_di_lettura.150677a5.svg";